import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        <section className="hero">
          <img
            className="hero__img"
            src={`${process.env.PUBLIC_URL || ""}/main/main1.jpg`}
            alt="Main 1"
          />
        </section>
        {/* New & Featured section */}
        <section className="bundles">
          <div className="bundles__grid">
            <a
              className="bundle"
              href="/shop"
              style={{
                backgroundImage: `url("${
                  process.env.PUBLIC_URL || ""
                }/main/main2-1.png")`,
              }}
            >
              <div className="bundle__title">LAMPS ›</div>
              <div className="bundle__desc">Designed in Portland, Oregon</div>
            </a>

            <a
              className="bundle"
              href="/shop"
              style={{
                backgroundImage: `url("${
                  process.env.PUBLIC_URL || ""
                }/main/main2-2.png")`,
              }}
            >
              <div className="bundle__title">
                IN-STOCK UPHOLSTERED FURNITURE ›
              </div>
              <div className="bundle__desc">Bestselling Monrowe Sofa</div>
            </a>

            <a
              className="bundle"
              href="/shop"
              style={{
                backgroundImage: `url("${
                  process.env.PUBLIC_URL || ""
                }/main/main2-3.png")`,
              }}
            >
              <div className="bundle__title">BEDDING ›</div>
              <div className="bundle__desc">New &amp; Bestselling Sets</div>
            </a>

            <a
              className="bundle"
              href="/shop"
              style={{
                backgroundImage: `url("${
                  process.env.PUBLIC_URL || ""
                }/main/main2-4.png")`,
              }}
            >
              <div className="bundle__title">ELEVATE THE EVERYDAY ›</div>
              <div className="bundle__desc">
                Beautiful solutions to enhance every space
              </div>
            </a>
          </div>
        </section>

        <section className="hero">
          <img
            className="hero__img"
            src={`${process.env.PUBLIC_URL || ""}/main/main3.jpg`}
            alt="Main 3"
          />
        </section>

        <section className="stories">
          <div className="stories__row">
            <div className="stories__copy">
              <h2 className="stories__title">
                Curate your space with solid brass lighting and hardware in
                finishes made to match.
              </h2>

              <div className="stories__thumbs">
                <a
                  className="stories__media"
                  href="/shop"
                  style={{
                    backgroundImage: `url("${
                      process.env.PUBLIC_URL || ""
                    }/main/main4-1.png")`,
                  }}
                ></a>
                <a
                  className="stories__media"
                  href="/shop"
                  style={{
                    backgroundImage: `url("${
                      process.env.PUBLIC_URL || ""
                    }/main/main4-2.png")`,
                  }}
                ></a>
              </div>
            </div>

            <div
              className="stories__media stories__media--large"
              style={{
                backgroundImage: `url("${
                  process.env.PUBLIC_URL || ""
                }/main/main4-3.jpg")`,
                width: "100%",
              }}
            ></div>
          </div>
        </section>

        <section className="hero">
          <img
            className="hero__img"
            src={`${process.env.PUBLIC_URL || ""}/main/main5.jpg`}
            alt="Main 5"
          />
        </section>

        <section className="hero">
          <img
            className="hero__img"
            src={`${process.env.PUBLIC_URL || ""}/main/main6.jpg`}
            alt="Main 6"
          />
        </section>

        <section className="hero">
          <img
            className="hero__img"
            src={`${process.env.PUBLIC_URL || ""}/main/main7.jpg`}
            alt="Main 7"
            style={{ height: "700px" }}
          />
        </section>

        <section className="hero hero--split">
          <div
            className="hero__split-left"
            style={{
              backgroundImage: `url("${
                process.env.PUBLIC_URL || ""
              }/main/main8.jpg")`,
              height: "166px",
            }}
          />
          <div
            className="hero__split-right"
            style={{
              backgroundImage: `url("${
                process.env.PUBLIC_URL || ""
              }/main/main8-1.jpg")`,
              height: "166px",
            }}
          />
        </section>

        {/* 9 - Features three-column section */}
        <section className="features">
          <div className="features__grid">
            <div className="feature">
              <img
                className="feature__img"
                src={`${process.env.PUBLIC_URL || ""}/main/main9-1.jpg`}
                alt="Project Boards"
              />
              <h3 className="feature__title">Introducing: Project Boards</h3>
              <p className="feature__desc">
                Save all your favorite inspiration images and products in one
                place.
              </p>
              <a className="feature__cta" href="/shop">
                START YOUR BOARD ›
              </a>
            </div>

            <div className="feature feature--center">
              <img
                className="feature__img feature__img--large"
                src={`${process.env.PUBLIC_URL || ""}/main/main9-2.jpg`}
                alt="Katie Bowling"
              />
              <h3 className="feature__title">Katie Bowling</h3>
              <p className="feature__desc">
                Meet our Project Collective partner and shop her favorite looks.
              </p>
              <a className="feature__cta" href="/shop">
                SHOP NOW ›
              </a>
            </div>

            <div className="feature">
              <img
                className="feature__img"
                src={`${process.env.PUBLIC_URL || ""}/main/main9-3.jpg`}
                alt="Design Crew"
              />
              <h3 className="feature__title">Design Crew</h3>
              <p className="feature__desc">
                From home projects to quick style advice, we’re here to help—for
                free.
              </p>
              <a className="feature__cta" href="/shop">
                SHOP NOW ›
              </a>
            </div>
          </div>
        </section>

        {/* 10 - Brands row */}
        <section className="brands">
          <h2 className="brands__title">
            DISCOVER EVEN MORE TO LOVE ACROSS OUR FAMILY OF BRANDS
          </h2>
          <div className="brands__grid">
            <a className="brand" href="/shop">
              <img
                src={`${process.env.PUBLIC_URL || ""}/main/main10-1.png`}
                alt="Pottery Barn"
              />
            </a>
            <a className="brand" href="/shop">
              <img
                src={`${process.env.PUBLIC_URL || ""}/main/main10-2.png`}
                alt="Pottery Barn Kids"
              />
            </a>
            <a className="brand" href="/shop">
              <img
                src={`${process.env.PUBLIC_URL || ""}/main/main10-3.png`}
                alt="Pottery Barn Teen"
              />
            </a>
            <a className="brand" href="/shop">
              <img
                src={`${process.env.PUBLIC_URL || ""}/main/main10-4.png`}
                alt="West Elm"
              />
            </a>
            <a className="brand" href="/shop">
              <img
                src={`${process.env.PUBLIC_URL || ""}/main/main10-5.png`}
                alt="Williams Sonoma"
              />
            </a>
            <a className="brand" href="/shop">
              <img
                src={`${process.env.PUBLIC_URL || ""}/main/main10-6.png`}
                alt="Williams Sonoma Home"
              />
            </a>
            <a className="brand" href="/shop">
              <img
                src={`${process.env.PUBLIC_URL || ""}/main/main10-7.png`}
                alt="Mark & Graham"
              />
            </a>
            <a className="brand" href="/shop">
              <img
                src={`${process.env.PUBLIC_URL || ""}/main/main10-8.png`}
                alt="GreenRow"
              />
            </a>
          </div>
        </section>

        {/* 11 - Top Trending Products */}
        <section className="trending">
          <div className="trending__inner">
            <h2 className="trending__title">Top Trending Products</h2>
            <div className="trending__grid">
              <div className="trending__card">
                <img
                  className="trending__img"
                  src={`${process.env.PUBLIC_URL || ""}/main/main11-1.jpg`}
                  alt="Wallace Vanity"
                />
                <div className="trending__name">Wallace 72" Double Vanity</div>
                <a className="trending__more" href="/shop">
                  SEE MORE LIKE THIS
                </a>
              </div>

              <div className="trending__card">
                <img
                  className="trending__img"
                  src={`${process.env.PUBLIC_URL || ""}/main/main11-2.jpg`}
                  alt="Sumaru Rug"
                />
                <div className="trending__name">Sumaru Hand-Knotted Rug</div>
                <a className="trending__more" href="/shop">
                  SEE MORE LIKE THIS
                </a>
              </div>

              <div className="trending__card">
                <img
                  className="trending__img"
                  src={`${process.env.PUBLIC_URL || ""}/main/main11-3.jpg`}
                  alt="Rounded Mirror"
                />
                <div className="trending__name">
                  Rounded Rectangle Metal Framed Mirror
                </div>
                <a className="trending__more" href="/shop">
                  SEE MORE LIKE THIS
                </a>
              </div>

              <div className="trending__card">
                <img
                  className="trending__img"
                  src={`${process.env.PUBLIC_URL || ""}/main/main11-4.jpg`}
                  alt="Barnes Vanity"
                />
                <div className="trending__name">Barnes 48" Single Vanity</div>
                <a className="trending__more" href="/shop">
                  SEE MORE LIKE THIS
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
